// Importing images
import IPIsolationPacker from "../../../assets/downHoleTools/highPerformancePacker/IPIsolationPacker.png";
import HRPacker from "../../../assets/downHoleTools/highPerformancePacker/HRPacker.png";
import SwellablePacker from "../../../assets/downHoleTools/highPerformancePacker/SwellablePacker.png";
import Y341InjectionPacker from "../../../assets/downHoleTools/highPerformancePacker/Y341InjectionPacker.png";
import DESPCableThoughPacker from "../../../assets/downHoleTools/highPerformancePacker/D-ESPCableThoughPacker.png";
import PRHSProductionPacker from "../../../assets/downHoleTools/highPerformancePacker/PRHSProductionPacker.png";
import Y531FracturingPacker from "../../../assets/downHoleTools/highPerformancePacker/Y531FracturingPacker.png";
import Y211Packer from "../../../assets/downHoleTools/highPerformancePacker/Y211Packer.png";
import JMPremiumScreen from "../../../assets/downHoleTools/qualitysandcontrolscreen/JMPremiumScreen.png";
import FloWiseWaterControlScreen from "../../../assets/downHoleTools/qualitysandcontrolscreen/FloWiseWaterControlScreen.png";
import BridgeMicroporousScreen from "../../../assets/downHoleTools/qualitysandcontrolscreen/BridgeMicroporousScreen.png";
import IntelligentWaterControl from "../../../assets/downHoleTools/waterControlDevice/intelligentWaterControl.png";
import ProductsAndServices from "../../../assets/downHoleTools/waterControlDevice/productsAndServices.png";
import IntelligentWaterControlMechanism from "../../../assets/downHoleTools/waterControlDevice/intelligentWaterControlMechanism.png";

//upperCompletionTool

import PGasVentValve from "../../../assets/downHoleTools/upperCompletionTool/PGasVentValve.png";
import KQuickConnectionSub from "../../../assets/downHoleTools/upperCompletionTool/KQuickConnectionSub.png";
import HydraulicAnchor from "../../../assets/downHoleTools/upperCompletionTool/HydraulicAnchor.png";
import YTool from "../../../assets/downHoleTools/upperCompletionTool/YTool.png";
import AFXSubsurfaceSafetyValve from "../../../assets/downHoleTools/upperCompletionTool/AFXSubsurfaceSafetyValve.png";
import InterruptedMakeupStabFishingSpear from "../../../assets/downHoleTools/completionServiceTools/InterruptedMakeupStabFishingSpear.png";
import PickingupandSettingdownTypeTripSpear from "../../../assets/downHoleTools/completionServiceTools/Picking-up-and-Setting-down-Type-Trip-Spear.png";
import FXFloatShoe from "../../../assets/downHoleTools/completionServiceTools/FX-Float-Shoe.png";
import SealBore from "../../../assets/downHoleTools/completionServiceTools/Seal-Bore.png";
import MGCProductionIsolationSealAssembly from "../../../assets/downHoleTools/completionServiceTools/MGC-Production-Isolation-Seal-Assembly.png";
import MGELatchSealAssembly from "../../../assets/downHoleTools/completionServiceTools/MGE-Latch-Seal-Assembly.png";

//Drilling Accessories

import RollerKellyBushing from "../../../assets/downHoleTools/DrillingAccessories/WellHeadTools/Roller-Kelly-Bushing.png";
import DrillToolLiftingSub from "../../../assets/downHoleTools/DrillingAccessories/WellHeadTools/Drill-Tool-Lifting-Sub.png";
import LiftingPlug from "../../../assets/downHoleTools/DrillingAccessories/WellHeadTools/Lifting-Plug.png";
import BitBreaker from "../../../assets/downHoleTools/DrillingAccessories/WellHeadTools/Bit-Breaker.png";
import Mudsplashbox from "../../../assets/downHoleTools/DrillingAccessories/WellHeadTools/Mud-splash-box.png";
import ModelLMudScraper from "../../../assets/downHoleTools/DrillingAccessories/WellHeadTools/Model-L-Mud-Scraper.png";
import DrillpipeRotaryToolInParts from "../../../assets/downHoleTools/DrillingAccessories/WellHeadTools/Drillpipe-Rotary-Tool-In-Parts.png";

// Drill Stem Tools

import CirculatingSub from "../../../assets/downHoleTools/DrillingAccessories/DrillStemTools/Circulating-Sub.png";
import DrillToolStabilizer from "../../../assets/downHoleTools/DrillingAccessories/DrillStemTools/Drill-Tool-Stabilizer.jpg";
import ReversingSub from "../../../assets/downHoleTools/DrillingAccessories/DrillStemTools/Reversing-Sub.png";
import TypeFTDropinCheckValve from "../../../assets/downHoleTools/DrillingAccessories/DrillStemTools/Type-FT-Drop-in-Check-Valve.png";
import DrillingReamer from "../../../assets/downHoleTools/DrillingAccessories/DrillStemTools/Drilling-Reamer.png";
import NonRotatingStabilizer from "../../../assets/downHoleTools/DrillingAccessories/DrillStemTools/Non-Rotating-Stabilizer.png";
import KellyValve from "../../../assets/downHoleTools/DrillingAccessories/DrillStemTools/Kelly-Valve.png";
import FullopeningValve from "../../../assets/downHoleTools/DrillingAccessories/DrillStemTools/Full-opening-Valve.png";
import InsideBlowoutPreventer from "../../../assets/downHoleTools/DrillingAccessories/DrillStemTools/Inside-Blowout-Preventer.png";

//

import OrientedBentSub from "../../../assets/downHoleTools/DrillingAccessories/OrientationTool/Oriented-Bent-Sub.png";


//Coring Tools

import CoringTools from "../../../assets/downHoleTools/DrillingAccessories/CoringTools/Coring-Tools.png";


//Cementing Tools

import FloatShoeAndFloatCollar from "../../../assets/downHoleTools/DrillingAccessories/CementingTools/Float-Shoe-And-Float-Collar.png";

//Down Hole Service Tools

import ImpressionsBlock from "../../../assets/downHoleTools/DrillingAccessories/DownHoleServiceTools/Impressions-Block.png";
import HighEfficiencyMillTaps from "../../../assets/downHoleTools/DrillingAccessories/DownHoleServiceTools/High-Efficiency-Mill-Taps.jpg";
import STTypeCasingPressureTestingPlug from "../../../assets/downHoleTools/DrillingAccessories/DownHoleServiceTools/ST-Type-Casing-Pressure-Testing-Plug.png";
import NDJMechanicalInternalCutter from "../../../assets/downHoleTools/DrillingAccessories/DownHoleServiceTools/ND-J-Mechanical-Internal-Cutter.png";
import MechanicalExternalCutter from "../../../assets/downHoleTools/DrillingAccessories/DownHoleServiceTools/Mechanical-External-Cutter.png";
import GXTypeCasingScraper from "../../../assets/downHoleTools/DrillingAccessories/DownHoleServiceTools/GX-Type-Casing-Scraper.png";
import LBFishingCup from "../../../assets/downHoleTools/DrillingAccessories/DownHoleServiceTools/LB-Fishing-Cup.png";
import ModelJKQKeySeatReamer from "../../../assets/downHoleTools/DrillingAccessories/DownHoleServiceTools/Model-JKQ-Key-Seat-Reamer.png";

// Fishing Tools

import LTTTypeReleasingOvershot from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/LT-T-Type-Releasing-Overshot.png";
import SuckerRodOvershot from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/Sucker-Rod-Overshot.png";
import DLTTTypeReleasableReversingOvershot from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/DLT-T-Type-Releasable-Reversing-Overshot.png";
import SliderSlipSpear from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/Slider-Slip-Spear.png";
import ReleasingSlipSpear from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/Releasing-Slip-Spear.png";
import CLFTypeReverseCirculationFishingMagnet from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/CLF-Type-Reverse-Circulation-Fishing-Magnet.png";
import CLTypeNormalCirculationFishingMagnet from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/CL-Type-Normal-Circulation-Fishing-Magnet.png";
import CKCLTypeFishingMagnet from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/CK-CL-Type-Fishing-Magnet.png";
import LLFTypeReverseCirculationJunkBasket from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/LLF-Type-Reverse-Circulation-Junk-Basket.png";
import ConeFisher from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/Cone-Fisher.png";
import DLQMultiFunctionalFisher from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/DLQ-Multi-Functional-Fisher.png";
import PinTapBoxTap from "../../../assets/downHoleTools/DrillingAccessories/FishingTools/Pin-Tap-&-Box-Tap.png";


//Milling Tools 

import HighEfficiencyGrindshoes from "../../../assets/downHoleTools/DrillingAccessories/MillingTools/High-Efficiency-Grind-(mill)-shoes.png";



//Bits

import DiamondBitsAndDiamondCoringBits from "../../../assets/downHoleTools/DrillingAccessories/Bits/Diamond-Bits-And-Diamond-Coring-Bits.png";


//Oil Soluble Temporary Plugging Agent

import OilSolubleTemporaryPluggingAgent from "../../../assets/downHoleTools/OilSolubleTemporaryPluggingAgent/Oil-Soluble-Temporary-Plugging-Agent.png";


// Array of tool images
const tools = [
  { id: 1, image: IPIsolationPacker, title: "IP Isolation Packer" },
  { id: 2, image: HRPacker, title: "HR Packer" },
  { id: 3, image: SwellablePacker, title: "Swellable Packer" },
  { id: 4, image: Y341InjectionPacker, title: "Y341 Injection Packer" },
  { id: 5, image: DESPCableThoughPacker, title: "D-ESP Cable Though Packer" },
  { id: 6, image: PRHSProductionPacker, title: "PRHS Production Packer" },
  { id: 7, image: Y531FracturingPacker, title: "Y531 Fracturing Packer" },
  { id: 8, image: Y211Packer, title: "Y211 Packer" },
  { id: 9, image: JMPremiumScreen, title: "JMPremium Screen" },
  {
    id: 10,
    image: FloWiseWaterControlScreen,
    title: " AICD & AICVWater Control Screen",
  },
  {
    id: 11,
    image: BridgeMicroporousScreen,
    title: "Bridge-type precision microporous screen",
  },
  {
    id: 12,
    image: IntelligentWaterControl,
    title: "Intelligent Water Control Device System",
  },
  { id: 13, image: ProductsAndServices, title: "Products and Services" },
  {
    id: 14,
    image: IntelligentWaterControlMechanism,
    title: "Intelligent Water Control Mechanism",
  },
  {
    id: 15,
    image: PGasVentValve,
    title: "P Gas Vent Valve",
  },
  {
    id: 16,
    image: KQuickConnectionSub,
    title: "K Quick Connection Sub",
  },
  {
    id: 17,
    image: HydraulicAnchor,
    title: "Hydraulic Anchor",
  },
  { id: 18, image: YTool, title: "Y Tool" },
  {
    id: 19,
    image: AFXSubsurfaceSafetyValve,
    title: "AFX Subsurface Safety Valve",
  },

  {
    id: 20,
    image: InterruptedMakeupStabFishingSpear,
    title: "Interrupted Make-up Stab Fishing Spear",
  },
  {
    id: 21,
    image: PickingupandSettingdownTypeTripSpear,
    title: "Picking up and Setting down Type Trip Spear",
  },
  {
    id: 22,
    image: FXFloatShoe,
    title: "FX Float Shoe",
  },
  {
    id: 23,
    image: SealBore,
    title: "Seal Bore",
  },
  {
    id: 24,
    image: MGCProductionIsolationSealAssembly,
    title: "MGC Production Isolation Seal Assembly",
  },
  {
    id: 25,
    image: MGELatchSealAssembly,
    title: "MGE Latch Seal Assembly",
  },

  {
    id: 26,
    image: RollerKellyBushing,
    title: "Roller Kelly Bushing",
  },
  {
    id: 27,
    image: DrillToolLiftingSub,
    title: "Drill Tool Lifting Sub",
  },
  {
    id: 28,
    image: LiftingPlug,
    title: "Lifting Plug",
  },
  {
    id: 29,
    image: BitBreaker,
    title: "Bit Breaker",
  },
  {
    id: 30,
    image: Mudsplashbox,
    title: "Mud splash box",
  },
  {
    id: 31,
    image: ModelLMudScraper,
    title: "Model L Mud Scraper",
  },
  {
    id: 32,
    image: DrillpipeRotaryToolInParts,
    title: "Drillpipe Rotary Tool In Parts",
  },
  {
    id: 33,
    image: CirculatingSub,
    title: "Circulating Sub",
  },
  {
    id: 34,
    image: DrillToolStabilizer,
    title: "Drill Tool Stabilizer",
  },
  {
    id: 35,
    image: ReversingSub,
    title: "Reversing Sub",
  },
  {
    id: 36,
    image: TypeFTDropinCheckValve,
    title: "Type FT Drop in Check Valve",
  },
  {
    id: 37,
    image: DrillingReamer,
    title: "Drilling Reamer",
  },
  {
    id: 38,
    image: NonRotatingStabilizer,
    title: "Non-Rotating Stabilizer",
  },
  {
    id: 39,
    image: KellyValve,
    title: "Kelly Valve",
  },
  {
    id: 40,
    image: FullopeningValve,
    title: "Full-opening Valve",
  },
  {
    id: 41,
    image: InsideBlowoutPreventer,
    title: "Inside Blowout Preventer",
  },
  {
    id: 41,
    image: OrientedBentSub,
    title: "Oriented Bent Sub",
  },
  {
    id: 42,
    image: CoringTools,
    title: "Coring Tools",
  },
  {
    id: 43,
    image:  FloatShoeAndFloatCollar,
    title: " Float Shoe And Float Collar",
  },
  {
    id: 44,
    image:  ImpressionsBlock,
    title: "Impressions Block",
  },
  {
    id: 45,
    image:  HighEfficiencyMillTaps,
    title: "High Efficiency Mill Taps",
  },
  {
    id: 46,
    image:  STTypeCasingPressureTestingPlug,
    title: "ST Type Casing Pressure Testing Plug",
  },
  {
    id: 47,
    image:  NDJMechanicalInternalCutter,
    title: "ND-J Mechanical Internal Cutter",
  },
  {
    id: 48,
    image:  MechanicalExternalCutter,
    title: "Mechanical External Cutter",
  },
  {
    id: 49,
    image:  GXTypeCasingScraper,
    title: "GX Type Casing Scraper",
  },
  {
    id: 50,
    image:  LBFishingCup,
    title: "LB Fishing Cup",
  },
  {
    id: 51,
    image:  ModelJKQKeySeatReamer,
    title: "Model JKQ Key Seat Reamer",
  },
  {
    id: 52,
    image:  LTTTypeReleasingOvershot,
    title: "LT-T Type Releasing Overshot",
  },
  {
    id: 53,
    image:  SuckerRodOvershot,
    title: "Sucker Rod Overshot",
  },
  {
    id: 54,
    image:  DLTTTypeReleasableReversingOvershot,
    title: "DLT-T Type Releasable Reversing Overshot",
  },
  {
    id: 55,
    image:  SliderSlipSpear,
    title: "Slider Slip Spear",
  },
  {
    id: 56,
    image:  ReleasingSlipSpear,
    title: "Releasing Slip Spear",
  },
  {
    id: 57,
    image:  CLFTypeReverseCirculationFishingMagnet,
    title: "CLF Type Reverse Circulation Fishing Magnet",
  },
  {
    id: 58,
    image:  CLTypeNormalCirculationFishingMagnet,
    title: "CL Type Normal Circulation Fishing Magnet",
  },
  {
    id: 59,
    image:  CKCLTypeFishingMagnet,
    title: "CK-CL Type Fishing Magnet",
  },
  {
    id: 60,
    image:  LLFTypeReverseCirculationJunkBasket,
    title: "LLF Type Reverse Circulation Junk Basket",
  },
  {
    id: 61,
    image:  ConeFisher,
    title: "Cone Fisher",
  },
  {
    id: 62,
    image:  DLQMultiFunctionalFisher,
    title: "DLQ Multi Functional Fisher",
  },
  {
    id: 63,
    image:  PinTapBoxTap,
    title: "Pin Tap & Box Tap",
  },
  {
    id: 64,
    image:   HighEfficiencyGrindshoes,
    title: "High Efficiency Grind (mill) shoes",
  },
  {
    id: 65,
    image:   DiamondBitsAndDiamondCoringBits,
    title: "Diamond Bits And Diamond Coring Bits",
  },
  {
    id: 66,
    image:   OilSolubleTemporaryPluggingAgent,
    title: "Oil Soluble Temporary Plugging Agent",
  },
];

export default tools;
